<script setup lang="ts">
const props = defineProps<{
  addedOnce?: None | ((item: CartItem['cart']) => void)
  count: number | None
}>()

const off = shallowRef(false)
function added(item: CartItem['cart']) {
  if (!off.value) {
    off.value = true
    props.addedOnce?.(item)
  }
}

const uiCount = computed(() => helpers.toPositive(props.count, 0))
</script>

<template>
  <div :class="$style.cart" class="_relative _row _ctrY">
    <IconCart />
    <span v-if="uiCount" :class="$style.size">{{ uiCount }}</span>
    <LazyCartIconAnimation v-if="addedOnce" :added />
  </div>
</template>

<style module>
.cart {
  color: currentColor;
  cursor: pointer;
  margin: 0;
}

:global(.CartIcon) .cart::before {
  content: '';
  display: block;
  top: -6px;
  left: 0px;
  height: 44px;
  width: 44px;
  position: absolute;
  border-radius: 50%;
  z-index: -1;
  background: var(--black-5);
  opacity: 0.01;
  transform: scale(1.05);
}

:global(.CartIconActive) .cart::before {
  opacity: 0.99;
}

.size {
  composes: global(_absolute);
  composes: global(_fs1);
  composes: global(_fw-l);
  composes: global(_h14);
  composes: global(_br99);
  composes: global(_ctr);
  composes: global(_ls-xs);

  min-width: 14px;

  composes: global(_mta);
  composes: global(_mba);
  composes: global(_mla);
  composes: global(_mra);

  background: var(--blue3);
  composes: global(_c0);
  line-height: 11px;
  right: -2px;
  bottom: -1px;
  padding: 1px 2px 0 3px;
}
</style>
